import { render } from "./SelecionarTipoElemento.vue?vue&type=template&id=5a584c4a&ts=true"
import script from "./SelecionarTipoElemento.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoElemento.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__